import type {
  ApiQuestionnaireOrigin,
  ApiQuestionnaireStatus,
  ObservationOrigin,
  ObservationStatus,
} from '../constants';
import type { ApiQuestionnaireListItem, ChildObservation } from '../types';

const ORIGIN_MAP: Readonly<Record<ApiQuestionnaireOrigin, ObservationOrigin>> = {
  scheduled: 'automatic',
  extra: 'group',
  extra_portal: 'manager',
};

const STATUS_MAP: Readonly<Record<ApiQuestionnaireStatus, ObservationStatus>> = {
  completed: 'completed',
  in_progress: 'pending',
  expired: 'expired',
  created: 'todo',
  deleted: 'deleted',
};

export const toChildObservation = (api: ApiQuestionnaireListItem): ChildObservation => ({
  id: api.id,
  origin: ORIGIN_MAP[api.origin],
  status: STATUS_MAP[api.status],
  dueDate: api.availableUntil,
  filledInBy: api.respondentFullName,
  completedAt: api.finishedAt,
});
